// extracted by mini-css-extract-plugin
export default {"rating":"IS-z","numberOfStars":"JS-z","count":"KS-z","barGraphSpacing":"LS-z","barGraph":"MS-z"};